import { Data_getInstanced8t5fpxsibwv as Data_getInstance } from './adapter/DeleteSecretMutation_ResponseAdapter.mjs';
import { getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Companion_getInstance1m1mmkl5t8eg3 as Companion_getInstance } from './type/Mutation.mjs';
import { Builder320ghmibyd2no as Builder } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CompiledGraphQL.mjs';
import { DeleteSecretMutationSelections_getInstance2i02ypr5sfk3e as DeleteSecretMutationSelections_getInstance } from './selections/DeleteSecretMutationSelections.mjs';
import { DeleteSecretMutation_VariablesAdapter_instance3kui7m920s6rc as DeleteSecretMutation_VariablesAdapter_instance } from './adapter/DeleteSecretMutation_VariablesAdapter.mjs';
import { Mutationkenyz0l5btz as Mutation } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Mutation.mjs';
import { ApolloAdaptableWith1g871415y7ifs as ApolloAdaptableWith } from '../../../../../../apollo-kotlin-apollo-annotations/com/apollographql/apollo/annotations/ApolloAdaptableWith.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data() {
  if (DataClass === VOID) {
    class $ {
      constructor(deleteSecret) {
        this.l6f_1 = deleteSecret;
      }
      toString() {
        return 'Data(deleteSecret=' + this.l6f_1 + ')';
      }
      hashCode() {
        return this.l6f_1 == null ? 0 : getBooleanHashCode(this.l6f_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Data()))
          return false;
        if (!(this.l6f_1 == other.l6f_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Data', VOID, VOID, VOID, VOID, VOID, {1: Data_getInstance});
    DataClass = $;
  }
  return DataClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.m6f_1 = obj(Data_getInstance());
        this.n6f_1 = (new (Builder())('data', Companion_getInstance().x6d_1)).t43(DeleteSecretMutationSelections_getInstance().q6f_1).j37();
        this.o6f_1 = '5a55c69595e1569210aeaa4dfc459e9c525775865fce9c5a8fbfdc346149c2c8';
        this.p6f_1 = 'deleteSecret';
      }
      a6e() {
        return 'mutation deleteSecret($input: DeleteSecretInput!) { deleteSecret(input: $input) }';
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var DeleteSecretMutationClass;
function DeleteSecretMutation() {
  if (DeleteSecretMutationClass === VOID) {
    class $ {
      constructor(input) {
        Companion_getInstance_0();
        this.r6f_1 = input;
      }
      c6e() {
        return '5a55c69595e1569210aeaa4dfc459e9c525775865fce9c5a8fbfdc346149c2c8';
      }
      operationId() {
        return this.c6e();
      }
      m47() {
        return Companion_getInstance_0().a6e();
      }
      d6e() {
        return 'deleteSecret';
      }
      operationName() {
        return this.d6e();
      }
      q46(writer, customScalarAdapters, withDefaultValues) {
        DeleteSecretMutation_VariablesAdapter_instance.s6f(writer, this, customScalarAdapters, withDefaultValues);
      }
      p46() {
        return Companion_getInstance_0().m6f_1;
      }
      toString() {
        return 'DeleteSecretMutation(input=' + this.r6f_1.toString() + ')';
      }
      hashCode() {
        return this.r6f_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DeleteSecretMutation()))
          return false;
        if (!this.r6f_1.equals(other.r6f_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'DeleteSecretMutation', VOID, VOID, [Mutation()]);
    DeleteSecretMutationClass = $;
  }
  return DeleteSecretMutationClass;
}
//region block: exports
export {
  Data as Data19yd1q1ikzzyl,
  DeleteSecretMutation as DeleteSecretMutation2wndasm4ltzuw,
};
//endregion

//# sourceMappingURL=DeleteSecretMutation.mjs.map
